import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardContent, CardHeader, IconButton, Typography, useTheme, Collapse } from '@mui/material';
import { useState } from 'react';
import BackgroundPattern from '@public/assets/images/event-card-bg.png';
import StyledCard from '@ui/pages/Home/components/FullHeightCard/StyledCard';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
const SponsorshipCard = ({ padding, variant = 'light', icon, heading, secondaryHeading, children, bgPattern = false, bgPosition, onClick, haveHeader = true, innerHeading = false, sx, chips, accordion = false, defaultExpanded = true, customButton, contentPadding = false, slider = false, disableBackground = false, disableShadow = false, disableBorders = false, textAlignCenter = false, dualHeader = false, secondaryContent, height, headerVericalAlign = false }) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(defaultExpanded);
    const getBgPatternStyles = (position) => ({
        backgroundImage: `url(${BackgroundPattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: position,
        backgroundSize: 'cover'
    });
    if (dualHeader) {
        return (_jsxs(StyledCard, { customVariant: variant, disableBackground: disableBackground, disableShadow: disableShadow, disableBorders: disableBorders, sx: [
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: height ? `${height} !important` : '100%',
                    overflow: 'hidden'
                },
                ...(Array.isArray(sx) ? sx : [sx || {}])
            ], children: [_jsxs(Box, { sx: { display: 'flex', width: '100%' }, children: [_jsx(Box, { sx: { flex: 1 }, children: haveHeader && (_jsx(CardHeader, { sx: {
                                    '& .MuiCardHeader-content': {
                                        minWidth: 0
                                    },
                                    flexDirection: headerVericalAlign ? 'column' : 'row',
                                    alignItems: headerVericalAlign ? 'flex-start' : 'center',
                                    gap: headerVericalAlign ? theme.spacing(1) : 0
                                }, avatar: icon && icon, title: heading && (_jsx(Typography, { variant: 'h5', color: variant === 'gradient' ? 'inherit' : theme.palette.text.primary, fontWeight: 500, children: heading })) })) }), _jsx(Box, { sx: { flex: 1 }, children: haveHeader && (_jsx(CardHeader, { sx: {
                                    '& .MuiCardHeader-content': {
                                        minWidth: 0
                                    },
                                    flexDirection: headerVericalAlign ? 'column' : 'row',
                                    alignItems: headerVericalAlign ? 'flex-start' : 'center',
                                    gap: headerVericalAlign ? theme.spacing(1) : 0
                                }, title: secondaryHeading && (_jsx(Typography, { variant: 'subtitle1', color: variant === 'gradient' ? 'inherit' : theme.palette.text.primary, fontWeight: 500, children: secondaryHeading })), action: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [accordion && (_jsx(IconButton, { onClick: () => setExpanded((prev) => !prev), sx: {
                                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s',
                                                border: 'none'
                                            }, children: _jsx(ExpandMoreIcon, { sx: {
                                                    color: variant === 'gradient' ? 'inherit' : theme.palette.text.tertiary
                                                } }) })), customButton] }) })) })] }), _jsxs(Box, { sx: { display: 'flex', width: '100%', flex: 1 }, children: [_jsx(Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column' }, children: _jsx(CardContent, { sx: {
                                    padding: padding,
                                    position: 'relative',
                                    '&:last-child': { paddingBottom: contentPadding ? 0 : 3 },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    minHeight: 0,
                                    overflow: 'hidden'
                                }, children: children }) }), _jsx(Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column' }, children: _jsx(CardContent, { sx: {
                                    padding: padding,
                                    position: 'relative',
                                    '&:last-child': { paddingBottom: contentPadding ? 0 : 3 },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    minHeight: 0,
                                    overflow: 'hidden'
                                }, children: secondaryContent }) })] })] }));
    }
    return (_jsxs(StyledCard, { customVariant: variant, disableBackground: disableBackground, disableShadow: disableShadow, disableBorders: disableBorders, sx: [
            {
                display: 'flex',
                flexDirection: 'column',
                height: accordion ? 'auto' : height ? height : '100%',
                overflow: 'hidden'
            },
            ...(bgPattern ? [getBgPatternStyles(bgPosition || 'top -105px left 10px')] : []),
            ...(Array.isArray(sx) ? sx : [sx || {}])
        ], onClick: !accordion ? onClick : undefined, children: [haveHeader && (_jsx(CardHeader, { sx: {
                    '& .MuiCardHeader-content': {
                        minWidth: 0
                    },
                    '& .MuiCardHeader-action': {
                        alignSelf: headerVericalAlign ? 'flex-end' : undefined
                    },
                    flexDirection: headerVericalAlign ? 'column' : 'row',
                    alignItems: headerVericalAlign ? 'flex-start' : 'center',
                    gap: headerVericalAlign ? theme.spacing(1) : 0
                }, avatar: icon && icon, title: (heading || (chips && chips.length > 0)) && (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, children: [heading && (_jsx(Typography, { whiteSpace: innerHeading ? 'nowrap' : undefined, textOverflow: innerHeading ? 'ellipsis' : undefined, overflow: innerHeading ? 'hidden' : undefined, textAlign: textAlignCenter ? 'center' : undefined, variant: innerHeading ? 'caption' : 'h5', color: variant === 'light' ||
                                variant === 'primary' ||
                                variant === 'secondary' ||
                                variant === 'success'
                                ? theme.palette.text.primary
                                : variant === 'gradient'
                                    ? 'inherit'
                                    : theme.palette.text.primary, fontWeight: innerHeading ? 400 : 500, fontSize: innerHeading ? '12px' : undefined, children: heading })), chips && chips.length > 0 && (_jsx(Box, { display: 'flex', flexWrap: 'wrap', gap: 0.5, children: chips.map((chip, idx) => (_jsx(Box, { children: chip }, idx))) }))] })), action: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [slider && customButton, accordion && (_jsx(IconButton, { onClick: () => setExpanded((prev) => !prev), sx: {
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s',
                                border: 'none'
                            }, children: _jsx(ExpandMoreIcon, { sx: {
                                    color: variant === 'gradient' ? 'inherit' : theme.palette.text.tertiary
                                } }) })), !slider && customButton] }) })), _jsx(Collapse, { in: !accordion || expanded, children: _jsx(CardContent, { sx: {
                        padding: padding,
                        position: 'relative',
                        '&:last-child': { paddingBottom: contentPadding ? 0 : 3 },
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        minHeight: 0,
                        overflow: 'hidden'
                    }, children: children }) })] }));
};
export default SponsorshipCard;
